import { Card } from "antd";
import { renderDay } from "../../../utils/constants";
import dayjsNormal from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

export const RenderInterpretesSchedules = ({
  schedules,
  interprete = null,
}) => {
  const { t } = useTranslation();
  const format = "HH:mm";

  return interprete !== null ? (
    <div>
      <Card
        title={t("RenderInterpretesSchedules.title")}
        style={{ borderColor: "red", backgroundColor: "#FEEBEB" }}
      >
        {schedules
          .filter(f => !f.disabled)
          .map((schedule, scheduleId) => {
            return (
              <div
                key={schedule._id}
                style={{
                  marginBottom: 15,
                }}
              >
                <span>{renderDay(schedule.day)}</span>
                <br />
                {schedule.times.map((time, timeId) => {
                  return (
                    <div key={time._id}>
                      <span>
                        <b>
                          {dayjsNormal(
                            `${time.from.hour}:${time.from.minute}`,
                            format,
                          ).format(format)}
                        </b>
                        -
                        <b>
                          {dayjsNormal(
                            `${time.to.hour}:${time.to.minute}`,
                            format,
                          ).format(format)}
                        </b>
                      </span>
                      <br />
                    </div>
                  );
                })}
              </div>
            );
          })}
      </Card>
    </div>
  ) : null;
};
